import { render, staticRenderFns } from "./PagePrivacidad.vue?vue&type=template&id=6a593e32&"
import script from "./PagePrivacidad.vue?vue&type=script&lang=js&"
export * from "./PagePrivacidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports